import { useLayoutEffect, useRef, WheelEvent as ReactWheelEvent } from "react";

import { useExplorerGlobals } from "contexts/explorerGlobals";
import { useMarkerRenderer } from "contexts/markerSvgRenderer/hooks";
import { LibSvgRenderer } from "features/engine2D/svgRenderer/LibSvgRenderer";
import { log } from "utils/log";

const l = log.svgRenderer.wrapper;

const SVG_ELEMENT_ID = "markers-container";

export function MarkerSvgRenderer({
    onWheelCapture,
}: Readonly<{
    onWheelCapture?: (e: ReactWheelEvent) => void;
}>) {
    const markerRendererRef = useMarkerRenderer();
    const svgElRef = useRef<SVGSVGElement | null>(null);
    const {
        state: { size, view },
    } = useExplorerGlobals();

    if (!view) {
        throw new Error("View not initialized");
    }

    useLayoutEffect(() => {
        const svgEl = svgElRef.current;
        if (!svgEl) {
            l.debug("useLayoutEffect - SVG element ref not available, skipping initialization");
            return;
        }

        l.debug("useLayoutEffect - Initializing markerRendererRef.current to new LibSvgRenderer()");
        markerRendererRef.current = new LibSvgRenderer(svgEl);
        return () => {
            markerRendererRef.current = null;
        };
    }, [markerRendererRef, view.convert.worldSpaceToScreenSpaceConverter]);

    return (
        <svg
            ref={svgElRef}
            id={SVG_ELEMENT_ID}
            width={size.width}
            height={size.height}
            style={{
                position: "absolute",
                left: 0,
                top: 0,
                pointerEvents: "none",
            }}
            onWheel={onWheelCapture}
        ></svg>
    );
}
